import {IHistory} from "../../../index";

interface IParamsDerivedValue {
    showDerivedValue: () => boolean
    history: IHistory
    tableColumn: ITableColumn<IHistory>
    getCellContent: () => string
}

type THistory_key = keyof IHistory;
type THistory_value = IHistory[THistory_key];
